import React from "react";
import "../styles/TutorialWindow.css";

const TutorialWindow = ({ visible, onToggleVisibility, tutorialContent }) => {

    // 处理 ESC 键关闭
  React.useEffect(() => {
    const handleEscKey = (e) => {
if (e.key === 'Escape' && visible) {
        if (onToggleVisibility) {
          onToggleVisibility();
        }
      }
    };

    if (visible) {
      document.addEventListener('keydown', handleEscKey);
      // 阻止背景滚动
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
}, [visible, onToggleVisibility]);


  if (!visible || !tutorialContent) {
    return null;
  }

  const { title, steps } = tutorialContent;
 // 处理关闭事件 - 确保调用正确的函数
  const handleClose = () => {
    if (onToggleVisibility) {
      onToggleVisibility();
    }
  };

  // 处理背景点击关闭
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };




return (
    <div className="tutorial-overlay" onClick={handleBackdropClick}>
      <div className="tutorial-container" onClick={(e) => e.stopPropagation()}>
      <div className="tutorial-header">
        <h2>{title}</h2>
<button 
          onClick={handleClose} 
          className="close-button"
          type="button"
          aria-label="Close tutorial"
        >
          ×
        </button>
      </div>

      <div className="tutorial-content">
        {steps.map((step, index) => (

          
          <div key={index} className="tutorial-step">
            <h3>{step.title}</h3>

            {(() => {
              let imgs = [];
              if (Array.isArray(step.image)) {
                // 兼容万一你以后真传了数组
                imgs = step.image;
              } else if (typeof step.image === "string") {
                const s = step.image.trim();
                if (s.includes(",") || s.includes("|")) {
                  // 支持 "a.jpg, b.jpg" 或 "a.jpg|b.jpg"
                  imgs = s
                    .split(/[,\|]/)
                    .map((t) => t.trim())
                    .filter(Boolean);
                } else if (s) {
                  imgs = [s];
                }
              } else if (Array.isArray(step.images)) {
                // 兼容可选的 images 字段
                imgs = step.images;
              }

              return imgs.length > 0 ? (
                imgs.length === 1 ? (
                  <img
                    src={imgs[0]}
                    alt={step.title}
                    className="tutorial-image"
                    loading="lazy"
                  />
                ) : (
                  <div
                    className={`tutorial-image-row image-count-${Math.min(
                      imgs.length,
                      3
                    )}`}
                  >
                    {imgs.map((src, idx) => (
                      <img
                        key={idx}
                        src={src}
                        alt={`${step.title} (${idx + 1})`}
                        className="tutorial-image"
                        loading="lazy"
                      />
                    ))}
                  </div>
                )
              ) : null;
            })()}

            <p>{step.content}</p>

            {/* 添加 Tips 显示部分 */}
            {step.tips && step.tips.length > 0 && (
              <div className="tutorial-tips">
                <h4 className="tips-header">💡 Tips:</h4>
                <ul className="tips-list">
                  {step.tips.map((tip, tipIndex) => (
                    <li key={tipIndex} className="tip-item">
                      {tip}
                    </li>
                  ))}
                </ul>
              </div>
            )}

{step.videoUrl && (
  <div className="tutorial-video-section">
    {(() => {
      const videoInfo = getVideoEmbedInfo(step.videoUrl);
      
      if (videoInfo) {
        return (
          <div className="tutorial-video-container">
            <iframe
              src={videoInfo.embedUrl}
              title="Tutorial Video"
              frameBorder="0"
              allowFullScreen
              className="tutorial-video-iframe"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
        );
      } else {
        // 如果不能识别视频类型，显示原来的链接
        return (
          <a
            href={step.videoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="tutorial-video-link"
          >
            Watch Video Tutorial
          </a>
        );
      }
    })()}
  </div>
)}
          </div>
))}
        
        {/* 底部关闭按钮 - 额外的关闭选项 */}
        <div className="tutorial-footer">
          <button 
            onClick={handleClose} 
            className="footer-close-button"
            type="button"
          >
            Close Tutorial
          </button>
        </div>
      </div>
    </div>
  </div>
);
};

const getVideoEmbedInfo = (videoUrl) => {
  if (!videoUrl) return null;
  
  // YouTube 视频
  const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/;
  const youtubeMatch = videoUrl.match(youtubeRegex);
  
  if (youtubeMatch) {
    return {
      type: 'youtube',
      id: youtubeMatch[1],
      embedUrl: `https://www.youtube.com/embed/${youtubeMatch[1]}`
    };
  }
  
  // Instagram 视频（Reel）
  const instagramRegex = /instagram\.com\/reel\/([^\/\?]+)/;
  const instagramMatch = videoUrl.match(instagramRegex);
  
  if (instagramMatch) {
    return {
      type: 'instagram',
      id: instagramMatch[1],
      embedUrl: `https://www.instagram.com/p/${instagramMatch[1]}/embed`
    };
  }
  
  // Vimeo 视频
  const vimeoRegex = /vimeo\.com\/(\d+)/;
  const vimeoMatch = videoUrl.match(vimeoRegex);
  
  if (vimeoMatch) {
    return {
      type: 'vimeo',
      id: vimeoMatch[1],
      embedUrl: `https://player.vimeo.com/video/${vimeoMatch[1]}`
    };
  }
  
  return null;
};

export default TutorialWindow;
